import Vue from 'vue'
import axios from 'axios'
import config from './config.json'

const axiosIns = axios.create({
  baseURL: config.baseURL,
  timeout: 0,
  // PROP-086: токен сессии переведён с localStorage на httpOnly-cookie. Чтобы браузер
  // прикреплял её к кросс-поддоменным запросам (kbtu.cubus.kz → kbtuapi.cubus.kz), а сервер
  // принимал ответ с Set-Cookie, нужны креденшелы на каждом запросе. Сервер отвечает
  // Access-Control-Allow-Credentials: true (supportsCredentials в CORS-конфиге).
  withCredentials: true,
})

Vue.prototype.$http = axiosIns

export default axiosIns

export const getConfig = () => config.baseURL

export const getAiAgentUrl = () => config.ai_agent_url || ''
